import {assertNever} from '@Utils/assert-never.util';
import {getEventWizardURLWithDesignPrefill} from '@Libraries/events.library';
import {MediaTypes} from '@Components/event-wizard/event-wizard-image-video/event-wizard-image-video.types';
import {PublishingOption} from '@Components/ai-chat-window/components/publishing-options/publishing-options.types';
import type {AiChatAssetKind} from '@Components/ai-chat-window/lib/publish-flow.types';

/**
 * The interstitial the desktop flow opens in a new tab. It materialises the asset into a poster and then
 * replaces itself with the wizard, so the chat tab never has to wait.
 */
export const getPublishPendingPageUrl = (assetKind: AiChatAssetKind, option: PublishingOption, hashedId: string): string => {
  return window.PMW.util.site_url(`ai/publishPending/${assetKind}/${option}/${hashedId}`);
};

/**
 * The wizard a finished publish job hands the user to. Its own module so the desktop pending page can resolve
 * a destination without importing the in-chat publish flow, which drags in the loading modal and the growl.
 */
export const getPublishDestinationUrl = (option: PublishingOption, posterHashedId: string): string => {
  switch (option) {
    case PublishingOption.PUBLISH_TO_SOCIAL_MEDIA:
      return window.PMW.util.site_url(`socialmedia/post/design/${posterHashedId}`);
    case PublishingOption.PROMOTE_AS_EVENT:
      return getEventWizardURLWithDesignPrefill(posterHashedId, MediaTypes.MY_DESIGNS);
    case PublishingOption.PUBLISH_AS_EMAIL_CAMPAIGN:
      return window.PMW.util.site_url(`emailmarketing/publish/design/${posterHashedId}`);
    default:
      return assertNever(option);
  }
};
